/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface InternalFailureErrorResponseContent
 */
export interface InternalFailureErrorResponseContent {
    /**
     * 
     * @type {string}
     * @memberof InternalFailureErrorResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the InternalFailureErrorResponseContent interface.
 */
export function instanceOfInternalFailureErrorResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function InternalFailureErrorResponseContentFromJSON(json: any): InternalFailureErrorResponseContent {
    return InternalFailureErrorResponseContentFromJSONTyped(json, false);
}

export function InternalFailureErrorResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalFailureErrorResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function InternalFailureErrorResponseContentToJSON(value?: InternalFailureErrorResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

